import type { ChatbaseEventHandler, ChatbaseEventName } from "../types";
import { addEventListener, removeEventListener } from "../api/chatbase-api";

/**
 * Manages Chatbase event subscriptions so they can be cleanly added and
 * removed without leaking references.
 */
export class EventManager {
  private listeners = new Map<string, Set<ChatbaseEventHandler>>();

  /** Subscribe to a Chatbase widget event. */
  on(event: ChatbaseEventName, handler: ChatbaseEventHandler): void {
    addEventListener(event, handler);

    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event)!.add(handler);
  }

  /** Unsubscribe a previously registered handler. */
  off(event: ChatbaseEventName, handler: ChatbaseEventHandler): void {
    removeEventListener(event, handler);
    this.listeners.get(event)?.delete(handler);
  }

  /** Remove all listeners tracked by this manager. */
  removeAll(): void {
    for (const [event, handlers] of this.listeners) {
      for (const handler of handlers) {
        removeEventListener(event, handler);
      }
      handlers.clear();
    }
    this.listeners.clear();
  }
}
